import { WorldTourFormat } from "model/Match/Set/WorldTour/Format/WorldTourFormat";
import { mapWorldTourScoring } from "./FsWorldTourScoring";
import { mapSetFormatBase } from "../FsSetFormat";
import { isPlayCondition } from "model/Match/PlayCondition";
import { FsWorldTourFormat } from "db/model/match/Set/WorldTour/FsWorldTourFormat";

export const mapWorldTourFormat = (
  fsModel: FsWorldTourFormat
): WorldTourFormat | undefined => {
  const base = mapSetFormatBase(fsModel);
  if (
    !base ||
    !fsModel.numTracks ||
    !fsModel.scoring ||
    !fsModel.trackWinReq ||
    !isPlayCondition(fsModel.playCondition)
  ) {
    return undefined;
  }

  const scoring = mapWorldTourScoring(fsModel.scoring);
  return {
    ...base,
    numTracks: fsModel.numTracks,
    playCondition: fsModel.playCondition,
    scoring,
    trackWinReq: fsModel.trackWinReq,
  };
};
